// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'voter-certified',
    appId: '1:732092749136:web:8482641fe486e579010855',
    storageBucket: 'voter-certified.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyDbwxaT5GWvE-VmPfGNgTSPFwEMgE8BPNc',
    authDomain: 'voter-certified.firebaseapp.com',
    messagingSenderId: '732092749136',
    measurementId: 'G-75ESJQPSRV',
  },
  production: false,
  useEmulators: true,
  firebaseConfig: {
    apiKey: 'AIzaSyDbwxaT5GWvE-VmPfGNgTSPFwEMgE8BPNc',
    authDomain: 'voter-certified.firebaseapp.com',
    projectId: 'voter-certified',
    storageBucket: 'voter-certified.appspot.com',
    messagingSenderId: '732092749136',
    appId: '1:732092749136:web:8482641fe486e579010855',
    measurementId: 'G-75ESJQPSRV',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
